// Action types for saving data
export const GET_DECLARATION_STATUS_REQUEST = 'GET_DECLARATION_STATUS_REQUEST';
export const GET_DECLARATION_STATUS_SUCCESS = 'GET_DECLARATION_STATUS_SUCCESS';
export const GET_DECLARATION_STATUS_FAILURE = 'GET_DECLARATION_STATUS_FAILURE';
export const GET_DECLARATION_STATUS_RESET = 'GET_DECLARATION_STATUS_RESET';
// Save data actions
export const getDeclarationStatusRequest = (payload) => ({
    type: GET_DECLARATION_STATUS_REQUEST,
    payload
});
export const getDeclarationStatusSuccess = (payload) => ({
    type: GET_DECLARATION_STATUS_SUCCESS,
    payload,
});
export const getDeclarationStatusFailure = (error) => ({
    type: GET_DECLARATION_STATUS_FAILURE,
    payload: error,
});
export const getDeclarationStatusReset = () => ({
    type: GET_DECLARATION_STATUS_RESET,
});
